import React, { FC, useEffect } from 'react';

import Modal from '~components/atoms/Modal';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch } from '~redux/hooks';
import CustomerCollateralDetails from '../CustomerCollateralDetails';

type GoldTransactionDetailsModalProps = {
    isOpen: boolean;
    onClose: () => void;
}

const CustomerCollateralDetailsModal: FC<GoldTransactionDetailsModalProps> = ({
    isOpen,
    onClose,
}) => {

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!isOpen) {
            dispatch(combinedActions.customerResetCustomerState());
        }
    }, [isOpen]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title='Collateral Details'
        >
            <CustomerCollateralDetails />
        </Modal>
    );
};

export default CustomerCollateralDetailsModal;
